module.exports = __webpack_public_path__ + "static/media/1.54bcf0b6.jpg";